export const AutoHideDuration = { fast: 2000 };
